export enum NotificationType {
  TimeOffRequested = 0,
  TimeOffRequestStatusUpdate = 1,
  RequestCreated = 2,

  /**
   * Recurring per-office reminder for resources to enter their capacity. Scheduled via an
   * OfficeNotificationSetting rather than triggered by an event. Mirrors the API enum ordinal.
   */
  ResourceCapacityReminder = 3,
  TaskAssigned = 4,
  MatterAssigned = 5,

  /**
   * Someone other than the owner changed which days an existing time off request covers.
   * Sent to the request's owner. Mirrors the API enum ordinal.
   */
  TimeOffRequestDaysAdjusted = 6,

  /**
   * The owner of an approved time off request changed it themselves (removed days, or cancelled
   * it). Sent to the approvers in the owner's practice area. Mirrors the API enum ordinal.
   */
  TimeOffRequestChangedByResource = 7,
}
